export enum App {
  website = 'website',
  checkout = 'checkout',
  pos = 'pos',
}
